import { useEffect, useState } from "react";
import { UseData } from "@/components/user/lib/services/UseData";
import ErrorHandler from "@/services/ErrorService/ErrorService";
import type {
	BillingPreviewType,
	SubscriptionPeriod,
	SubscriptionPlan,
} from "@/shared/components/PricingTable/types";

type Args = {
	newPeriod: SubscriptionPeriod;
	selectedPlan: SubscriptionPlan | null;
};

export function useGetBillingPreviewData(args: Args) {
	const { newPeriod, selectedPlan } = args;
	const [error, setError] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState(false);
	const [preview, setPreview] = useState<BillingPreviewType | null>(null);

	const { execute: getBillingPreview } =
		UseData.create().useGetStripeBillingPreview();

	useEffect(() => {
		if (!selectedPlan) return;
		setError(null);
		setIsLoading(true);
		setPreview(null);

		getBillingPreview({ period: newPeriod, plan: selectedPlan })
			.then((response) => {
				setPreview(response?.invoice || null);
			})
			.catch((error) => {
				ErrorHandler.logError(error);
				setError("Something went wrong. Please try again later.");
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, [getBillingPreview, newPeriod, selectedPlan]);

	return {
		error,
		isLoading,
		preview,
		setError,
		setIsLoading,
	};
}
